module.exports = __webpack_public_path__ + "img/error-internet.842bf99f.svg";